export const getDefaultControls = () => [
	{
		category: 'Text',
		description: '',
		items: [
			{
				clientId: 'headerText',
				controlType: 'textbox',
				label: 'Headline',
				value: 'Header goes here',
				tooltip: 'Enter here the text for the headline',
			},
			{
				clientId: 'titleText',
				controlType: 'textbox',
				label: 'Subheading',
				value: 'Title goes here',
				tooltip: 'Enter here the text for the title',
			},
			{
				clientId: 'bodyText',
				controlType: 'textarea',
				label: 'Body Copy',
				value: 'Body goes here',
				tooltip: 'Enter here the text for the body.',
			},
			{
				clientId: 'endingTagLineText',
				controlType: 'textbox',
				label: 'Ending Tag Line',
				value: 'Ending tag goes here',
				tooltip: 'Enter here the text for the ending tag line.',
			},
		],
	},
];

export const getBrandBuilderEditorIntialState = () => ({
	clientConnectAlertEmail: {
		alertId: null,
		borrowerFirstName: null,
		borrowerLastName: null,
		email: null,
		leadId: null,
		alertType: null,
	},

	campaignId: null,

	campaignLoading: false,

	variationMediasLoading: false,

	campaignItemMediasLoading: false,

	showLoader: false,

	smHideControls: false,

	completeVideo: '',

	prevBBRoute: 'media',

	routeAllowed: {
		design: false,
		additional: false,
	},

	campaignItems: [],

	mediasByVariantId: null,

	mediasByCampaignItemId: null,

	campaignDisclaimers: [],

	selectedMedia: {},

	/* Index position of the selected item in the media array. */
	selectedMediaType: null,

	mediaTypeArray: [
		{
			typeName: 'Flyer',
			icon: 'file-alt',
			iconWeight: 'fal',
			value: 'flyer',
			groupName: 'media-type',
			radioName: 'MediaType',
			index: 1,
			selected: false,
		},
		{
			typeName: 'Social Banner',
			icon: 'share-alt',
			iconWeight: 'fal',
			value: 'social-media',
			groupName: 'media-type',
			radioName: 'MediaType',
			index: 2,
			selected: false,
		},
		{
			typeName: 'Email',
			icon: 'envelope-open-text',
			iconWeight: 'fal',
			value: 'email-media',
			groupName: 'media-type',
			radioName: 'MediaType',
			index: 3,
			selected: false,
		},
		{
			typeName: 'Video',
			icon: 'film-alt',
			iconWeight: 'fal',
			value: 'video-media',
			groupName: 'media-type',
			radioName: 'MediaType',
			index: 4,
			selected: false,
		},
		{
			typeName: 'Presentation',
			icon: 'presentation',
			iconWeight: 'fal',
			value: 'presentation-media',
			groupName: 'media-type',
			radioName: 'MediaType',
			index: 5,
			selected: false,
		},
		{
			typeName: 'Pricing Flyer',
			icon: 'file-invoice-dollar',
			iconWeight: 'fal',
			value: 'pricing-flyer-media',
			groupName: 'media-type',
			radioName: 'MediaType',
			index: 6,
			selected: false,
		},
	],

	selectedAudienceType: null,

	audienceTypeArray: [
		{
			typeName: 'Borrower',
			icon: 'user',
			iconWeight: 'fal',
			value: 'borrower',
			groupName: 'audience-type',
			radioName: 'AudienceType',
			index: 1,
			selected: false,
		},
		{
			typeName: 'Real Estate Agent',
			icon: 'sign',
			iconWeight: 'fal',
			value: 'agent',
			groupName: 'audience-type',
			radioName: 'AudienceType',
			index: 2,
			selected: false,
		},
		{
			typeName: 'Builder / Contractor',
			icon: 'user-hard-hat',
			iconWeight: 'fal',
			value: 'builder/contractor',
			groupName: 'audience-type',
			radioName: 'AudienceType',
			index: 8,
			selected: false,
		},
		{
			typeName: 'Loan Officer',
			icon: 'user-tie',
			iconWeight: 'fal',
			value: 'loan-officer',
			groupName: 'audience-type',
			radioName: 'AudienceType',
			index: 9,
			selected: false,
		},
		{
			typeName: 'Title',
			icon: 'file-certificate',
			iconWeight: 'fal',
			value: 'title',
			groupName: 'audience-type',
			radioName: 'AudienceType',
			index: 10,
			selected: false,
		},
		{
			typeName: 'AMC',
			icon: 'user-graduate',
			iconWeight: 'fal',
			value: 'amc',
			groupName: 'audience-type',
			radioName: 'AudienceType',
			index: 11,
			selected: false,
		},
		{
			typeName: 'CPA',
			icon: 'tools',
			iconWeight: 'fal',
			value: 'cpa',
			groupName: 'audience-type',
			radioName: 'AudienceType',
			index: 12,
			selected: false,
		},
		{
			typeName: 'Insurance Agents',
			icon: 'user-tie',
			iconWeight: 'fal',
			value: 'insurance-agent',
			groupName: 'audience-type',
			radioName: 'AudienceType',
			index: 13,
			selected: false,
		},
		{
			typeName: 'Financial Advisor',
			icon: 'user-tie',
			iconWeight: 'fal',
			value: 'financial-advisor',
			groupName: 'audience-type',
			radioName: 'AudienceType',
			index: 14,
			selected: false,
		},
		{
			typeName: 'Divorce Attorney',
			icon: 'user-tie',
			iconWeight: 'fal',
			value: 'divorce-attorney',
			groupName: 'audience-type',
			radioName: 'AudienceType',
			index: 15,
			selected: false,
		},
	],

	filteredItems: [],

	selectedTemplate: null,

	selectedDesignIndex: null,

	selectedDesign: null,

	selectedTextVariationIndex: null,

	selectedControls: getDefaultControls(),

	controlValues: {
		headerText: 'Header goes here',
		titleText: 'Title goes here',
		bodyText: 'Body goes here',
		endingTagLineText: 'Ending tag goes here',
		Primary: '#fff',
		Secondary: '#fff',
		Image: 'whatevers',
	},

	selectedImageIndex: null,

	selectedImage: null,

	selectedColorIndex: null,

	selectedColors: {
		colorGroupTitle: 'My Brand Colors',
		name: 'color-choices',
		index: 0,
		colors: [
			{
				color: '#A6CC7B',
				title: 'Header Background Color',
			},
			{
				color: '#FFFFFF',
				title: 'Header Text Color',
			},
			{
				color: '#333333',
				title: 'Body Text Color',
			},
			{
				color: '#306199',
				title: 'Footer Background Color',
			},
			{
				color: '#FFFFFF',
				title: 'Footer Text Color',
			},
		],
		default: true,
	},

	socialArray: [
		{
			socialName: 'Post to Social Media',
			icon: 'share-alt-square',
			iconWeight: 'fal',
			index: 0,
			groupName: 'social',
			selected: false,
		},
	],
	// export items 2 & 3 are hidden in BBexport.vue
	exportTypeArray: [
		{
			cardText: 'Save as JPG',
			exportType: '.JPG',
			icon: 'file-alt',
			iconWeight: 'fal',
			filePath: '',
		},
		{
			cardText: 'Save as PNG',
			exportType: '.PNG',
			icon: 'file-alt',
			iconWeight: 'fal',
			filePath: '',
		},
		{
			cardText: 'Save as PDF',
			exportType: '.PDF',
			icon: 'file-pdf',
			iconWeight: 'fal',
			filePath: '',
		},
		{
			cardText: 'Send to Printer',
			exportType: 'print',
			icon: 'print',
			iconWeight: 'fal',
			filePath: '',
		},
	],
	videoExportTypeArray: [
		{
			exportType: '.mp4',
			icon: 'cloud-download',
			iconWeight: 'fal',
			filePath: '',
		},
		{
			exportType: '.mp4',
			icon: 'cloud-download',
			iconWeight: 'fal',
			filePath: '',
		},
		{
			exportType: '.mp4',
			icon: 'cloud-download',
			iconWeight: 'fal',
			filePath: '',
		},
		{
			exportType: '.mp4',
			icon: 'cloud-download',
			iconWeight: 'fal',
			filePath: '',
		},
	],
	selectedVideo: 0,
	selectedFlyer: null,
	subjectLine: '',
	defaultSubjectLine: '',
	// Set by LightiningOutInternal, used to control sending email alert to person selected in client connect
	manualEmailData: null,
	videoIsVertical: false,
});
